// Shared Design DNA option sets — used by the assessment (Questionnaire) and the
// client portal Design Studio so both stay in sync (single source of truth).

export const VISUAL_STYLE_OPTIONS = [
  "Warm & Welcoming", "Modern & Timeless", "Professional", "Elegant", "Bold",
  "Clean & Minimal", "Luxury", "Rustic", "Traditional", "Creative",
];
export const BRAND_PERSONALITY_OPTIONS = [
  "Trustworthy", "Friendly", "Innovative", "Family-Oriented", "Premium",
  "Community-Focused", "Inspirational", "Energetic",
];
export const VISUAL_PREF_OPTIONS = [
  "Large Photography", "Video Hero", "Lots of White Space", "Dark Theme", "Light Theme",
  "Rounded Design", "Sharp/Corporate", "Card Layout", "Full-width Sections",
];

export const MOOD_BY_INDUSTRY = {
  church: ["Biblically Grounded", "Christ-Centered", "Worship Focused", "Prayer Focused", "Community Focused", "Family Friendly", "Reverent", "Contemporary", "Traditional", "Mission Driven"],
  restaurant: ["Inviting", "Cozy", "Upscale", "Family Friendly", "Trendy", "Authentic", "Fresh & Local", "Fun & Casual"],
  nonprofit: ["Hopeful", "Compassionate", "Trustworthy", "Community Focused", "Mission Driven", "Empowering", "Grassroots", "Uplifting"],
  contractor: ["Rugged & Dependable", "Professional", "Trustworthy", "Established", "Local & Friendly", "Premium", "Safety-Focused", "Craftsmanship"],
};

const INDUSTRY_MATCH = {
  church: ["church", "ministry", "ministries", "faith", "parish", "congregation", "worship", "gospel", "chapel", "temple"],
  restaurant: ["restaurant", "cafe", "café", "diner", "bakery", "catering", "coffee", "bistro", "eatery", "grill", "pizzeria", "food truck", "food", "bar & grill"],
  nonprofit: ["nonprofit", "non-profit", "non profit", "charity", "foundation", "ngo", "cause", "community org"],
  contractor: ["contractor", "construction", "roofing", "roofer", "plumbing", "plumber", "hvac", "electrician", "electrical", "landscaping", "landscaper", "remodel", "builder", "trades", "painter", "concrete", "handyman", "fencing", "paving"],
};

export const detectIndustryKey = (industry) => {
  const s = (industry || "").toLowerCase();
  for (const [key, kws] of Object.entries(INDUSTRY_MATCH)) {
    if (kws.some((m) => s.includes(m))) return key;
  }
  return null;
};
